import { translations as PageHeaderTranslations } from 'components/page/i18n/locales/fr/translations';
import { translations as BulkActionFrTranslation } from 'containers/BulkAction/i18n/locales/fr/translations';
import { translations as CampaignTranslations } from 'containers/Campaign/i18n/locales/fr/translations';
import { translations } from 'containers/Customer/i18n/locales/fr/translations';
import { translations as IntelligenceTranslations } from 'containers/Intelligence/i18n/locales/fr/translations';
import { translations as MicrositeTranslations } from 'containers/Microsite/i18n/locales/fr/translations';
import { translations as OrbitTranslations } from 'containers/Orbit/i18n/locales/fr/translations';
import { translations as RewardFRTranslation } from 'containers/Reward/i18n/locales/fr/translations';
import { translations as RuleTranslations } from 'containers/Rule/i18n/locales/fr/translations';
import { translations as GlobalTranslations } from 'utils/globalTranslation/locales/fr/translations';
import {
  BulkActionModule,
  CampaignModule,
  CustomerModule,
  GlobalModule,
  MicrositeModule,
  IntelligenceModule,
  OrbitModule,
  PageHeaderModule,
  RewardModule,
  RuleModule
} from 'utils/i18n/TModules';

export const globalTranslations = {
  [GlobalModule]: GlobalTranslations,
  [BulkActionModule]: BulkActionFrTranslation,
  [CustomerModule]: translations,
  [CampaignModule]: CampaignTranslations,
  [MicrositeModule]: MicrositeTranslations,
  [PageHeaderModule]: PageHeaderTranslations,
  [RuleModule]: RuleTranslations,
  [RewardModule]: RewardFRTranslation,
  // Both registered in every locale so the module resolves here rather than through the global
  // fallback; both still carry EN strings pending translation (PLA-8815, PLA-8844).
  [IntelligenceModule]: IntelligenceTranslations,
  [OrbitModule]: OrbitTranslations
};
